import { createEventString, log } from "../log";
import getErrorMessage from "../getErrorMessage";
import getRedirectUrl from "./getRedirectUrl";

const getUserPurchaseRedirectUrl = async (
  email = "",
  brandId = "",
  user = { created_at: "", last_sign_in_at: "" }
) => {
  try {
    let needsToken = false;

    // if returning user, don't direct to welcome screen
    const createdAt = new Date(user.created_at);
    const lastSignIn = new Date(user?.last_sign_in_at);

    // only display welcome screen if lastSignIn was within a second of the createdAt
    if (lastSignIn.getTime() - createdAt.getTime() < 1000) {
      needsToken = true;
    }

    const redirectUrl =
      (await getRedirectUrl(email, needsToken, brandId)) || "";
    return redirectUrl;
  } catch (error) {
    const message = getErrorMessage(error);
    log({
      eventName: createEventString("modal", "error", "get_redirect_url"),
      eventMessage: "Unable to get the redirect url",
      eventData: {
        brand_id: brandId,
        email,
        error,
        error_message: message,
        user,
      },
      eventLevel: "error",
    });
  }
};

export default getUserPurchaseRedirectUrl;
